// utils
import { paramCase } from 'src/utils/change-case';
import { _id, _postTitles } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/kAYnYYdib0aQPNKZpgJT6J/%5BPreview%5D-Minimal-Web.v5.0.0?type=design&node-id=0%3A1&t=Al4jScQq97Aly0Mn-1',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  post: {
    root: `/post`,
    details: (title) => `/post/${paramCase(title)}`,
    demo: {
      details: `/post/${paramCase(MOCK_TITLE)}`,
    },
  },
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
      forgotPassword: `${ROOTS.AUTH}/jwt/forgot-password`,
      newPassword: `${ROOTS.AUTH}/jwt/new-password`,
    },


    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  authDemo: {
    classic: {
      login: `${ROOTS.AUTH_DEMO}/classic/login`,
      register: `${ROOTS.AUTH_DEMO}/classic/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/classic/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/classic/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/classic/verify`,
    },
    modern: {
      login: `${ROOTS.AUTH_DEMO}/modern/login`,
      register: `${ROOTS.AUTH_DEMO}/modern/register`,
      forgotPassword: `${ROOTS.AUTH_DEMO}/modern/forgot-password`,
      newPassword: `${ROOTS.AUTH_DEMO}/modern/new-password`,
      verify: `${ROOTS.AUTH_DEMO}/modern/verify`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    profile: `${ROOTS.DASHBOARD}/profile`,
    mail: `${ROOTS.DASHBOARD}/mail`,
    chat: `${ROOTS.DASHBOARD}/chat`,
    blank: `${ROOTS.DASHBOARD}/blank`,
    kanban: `${ROOTS.DASHBOARD}/kanban`,
    calendar: `${ROOTS.DASHBOARD}/calendar`,
    fileManager: `${ROOTS.DASHBOARD}/file-manager`,
    permission: `${ROOTS.DASHBOARD}/permission`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
      analytics: `${ROOTS.DASHBOARD}/analytics`,
      banking: `${ROOTS.DASHBOARD}/banking`,
      booking: `${ROOTS.DASHBOARD}/booking`,
      file: `${ROOTS.DASHBOARD}/file`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      events: (id) => `${ROOTS.DASHBOARD}/user/${id}/events`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    currencyExchange: {
      root: `${ROOTS.DASHBOARD}/currency-exchange`
    },
    profileAnalytics: {
      root: `${ROOTS.DASHBOARD}/profile-analytics`,
      list: `${ROOTS.DASHBOARD}/profile-analytics`
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/product/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/product/${MOCK_ID}/edit`,
      },
    },
    batches: {
      root: `${ROOTS.DASHBOARD}/batches`,
      new: `${ROOTS.DASHBOARD}/batches/new`,
      list: `${ROOTS.DASHBOARD}/batches/list`,
      // details: (id) => `${ROOTS.DASHBOARD}/category/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/batches/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/batches/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/batches/${MOCK_ID}/edit`,
      },
    },
    invoice: {
      root: `${ROOTS.DASHBOARD}/invoice`,
      new: `${ROOTS.DASHBOARD}/invoice/new`,
      details: (id) => `${ROOTS.DASHBOARD}/invoice/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/invoice/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/invoice/${MOCK_ID}/edit`,
      },
    },
    post: {
      root: `${ROOTS.DASHBOARD}/post`,
      new: `${ROOTS.DASHBOARD}/post/new`,
      list: `${ROOTS.DASHBOARD}/post/list`,
      details: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}`,
      edit: (title) => `${ROOTS.DASHBOARD}/post/${paramCase(title)}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}`,
        edit: `${ROOTS.DASHBOARD}/post/${paramCase(MOCK_TITLE)}/edit`,
      },
    },
    blogAuthor: {
      root: `${ROOTS.DASHBOARD}/blog-author`,
      new: `${ROOTS.DASHBOARD}/blog-author/new`,
      list: `${ROOTS.DASHBOARD}/blog-author/list`,
      details: (id) => `${ROOTS.DASHBOARD}/blog-author/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/blog-author/${id}/edit`,
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },
    job: {
      root: `${ROOTS.DASHBOARD}/job`,
      new: `${ROOTS.DASHBOARD}/job/new`,
      list: `${ROOTS.DASHBOARD}/job/list`,
      details: (id) => `${ROOTS.DASHBOARD}/job/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/job/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/job/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/job/${MOCK_ID}/edit`,
      },
    },
    category: {
      root: `${ROOTS.DASHBOARD}/category`,
      new: `${ROOTS.DASHBOARD}/category/new`,
      list: `${ROOTS.DASHBOARD}/category/list`,
      details: (id) => `${ROOTS.DASHBOARD}/category/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/category/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/category/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/category/${MOCK_ID}/edit`,
      },
    },
    faqCategory: {
      root: `${ROOTS.DASHBOARD}/faqCategory`,
      new: `${ROOTS.DASHBOARD}/faqCategory/new`,
      list: `${ROOTS.DASHBOARD}/faqCategory/list`,
      details: (id) => `${ROOTS.DASHBOARD}/faqCategory/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/faqCategory/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/faqCategory/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/faqCategory/${MOCK_ID}/edit`,
      },
    },
    faq: {
      root: `${ROOTS.DASHBOARD}/faq`,
      new: `${ROOTS.DASHBOARD}/faq/new`,
      list: `${ROOTS.DASHBOARD}/faq/list`,
      details: (id) => `${ROOTS.DASHBOARD}/faq/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/faq/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/faq/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/faq/${MOCK_ID}/edit`,
      },
    },
    tour: {
      root: `${ROOTS.DASHBOARD}/tour`,
      new: `${ROOTS.DASHBOARD}/tour/new`,
      details: (id) => `${ROOTS.DASHBOARD}/tour/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/tour/${id}/edit`,
      demo: {
        details: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}`,
        edit: `${ROOTS.DASHBOARD}/tour/${MOCK_ID}/edit`,
      },
    },
    plan: {
      root: `${ROOTS.DASHBOARD}/plan`,
      new: `${ROOTS.DASHBOARD}/plan/new`,
      list: `${ROOTS.DASHBOARD}/plan/list`,
      courseList: `${ROOTS.DASHBOARD}/plan/courseList`,
      serviceList: `${ROOTS.DASHBOARD}/plan/serviceList`,
      edit: (id) => `${ROOTS.DASHBOARD}/plan/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/plan/${id}/view`,
    },

    // blog: {
    //   root: `${ROOTS.DASHBOARD}/plan`,
    //   new: `${ROOTS.DASHBOARD}/plan/new`,
    //   list: `${ROOTS.DASHBOARD}/plan/list`,
    //   edit: (id) => `${ROOTS.DASHBOARD}/plan/${id}/edit`,
    //   view: (id) => `${ROOTS.DASHBOARD}/plan/${id}/view`,
    // },

    subscription: {
      root: `${ROOTS.DASHBOARD}/subscription`,
      list: `${ROOTS.DASHBOARD}/subscription/list`,
      details: (id) => `${ROOTS.DASHBOARD}/subscription/${id}`,

    },
    learnerProgress: {
      root: `${ROOTS.DASHBOARD}/learner-progress`,
      list: `${ROOTS.DASHBOARD}/learner-progress/list`,
      user: (userId) => `${ROOTS.DASHBOARD}/learner-progress/user/${userId}`,
      details: (id) => `${ROOTS.DASHBOARD}/learner-progress/${id}`,
    },
    email: {
      root: `${ROOTS.DASHBOARD}/email`,
      list: `${ROOTS.DASHBOARD}/email/list`,

    },

    contact: {
      root: `${ROOTS.DASHBOARD}/contact`,
      list: `${ROOTS.DASHBOARD}/contact/list`,


    },
    
    cmsPlays: {
      root: `${ROOTS.DASHBOARD}/cms-plays`,
      list: `${ROOTS.DASHBOARD}/cms-plays/list`,
      new: `${ROOTS.DASHBOARD}/cms-plays/new`,
      edit: (documentId) => `${ROOTS.DASHBOARD}/cms-plays/${documentId}/edit`,
    },

    pricingTiers: {
      root: `${ROOTS.DASHBOARD}/pricing/tiers`,
      list: `${ROOTS.DASHBOARD}/pricing/tiers`,
      new: `${ROOTS.DASHBOARD}/pricing/tiers/new`,
      grant: `${ROOTS.DASHBOARD}/pricing/tiers/grant`,
      edit: (documentId) => `${ROOTS.DASHBOARD}/pricing/tiers/${documentId}/edit`,
    },

    pricingPlans: {
      root: `${ROOTS.DASHBOARD}/pricing/plans`,
      list: `${ROOTS.DASHBOARD}/pricing/plans`,
      new: `${ROOTS.DASHBOARD}/pricing/plans/new`,
      edit: (documentId) => `${ROOTS.DASHBOARD}/pricing/plans/${documentId}/edit`,
    },

    domains: {
      root: `${ROOTS.DASHBOARD}/domains`,
      list: `${ROOTS.DASHBOARD}/domains`,
      new: `${ROOTS.DASHBOARD}/domains/new`,
      edit: (documentId) => `${ROOTS.DASHBOARD}/domains/${documentId}/edit`,
    },
    subdomains: {
      root: `${ROOTS.DASHBOARD}/sub-domains`,
      list: `${ROOTS.DASHBOARD}/sub-domains`,
      new: `${ROOTS.DASHBOARD}/sub-domains/new`,
      edit: (documentId) => `${ROOTS.DASHBOARD}/sub-domains/${documentId}/edit`,
    },

    homePage: {
      root: `${ROOTS.DASHBOARD}/marketing/home`,
    },

    announcementBanner: {
      root: `${ROOTS.DASHBOARD}/marketing/banner`,
    },

    cmsFaqs: {
      root: `${ROOTS.DASHBOARD}/marketing/faqs`,
      list: `${ROOTS.DASHBOARD}/marketing/faqs`,
      new: `${ROOTS.DASHBOARD}/marketing/faqs/new`,
      edit: (documentId) => `${ROOTS.DASHBOARD}/marketing/faqs/${documentId}/edit`,
    },

    testimonials: {
      root: `${ROOTS.DASHBOARD}/marketing/testimonials`,
      list: `${ROOTS.DASHBOARD}/marketing/testimonials`,
      new: `${ROOTS.DASHBOARD}/marketing/testimonials/new`,
      edit: (documentId) => `${ROOTS.DASHBOARD}/marketing/testimonials/${documentId}/edit`,
    },

    nativityTemplates: {
      root: `${ROOTS.DASHBOARD}/marketing/nativity-templates`,
      list: `${ROOTS.DASHBOARD}/marketing/nativity-templates`,
      new: `${ROOTS.DASHBOARD}/marketing/nativity-templates/new`,
      edit: (documentId) => `${ROOTS.DASHBOARD}/marketing/nativity-templates/${documentId}/edit`,
    },

    playPlatformSettings: {
      root: `${ROOTS.DASHBOARD}/play-platform-settings`,
    },

    memorySettings: {
      root: `${ROOTS.DASHBOARD}/memory/settings`,
    },

    memoryInsights: {
      root: `${ROOTS.DASHBOARD}/memory/insights`,
      users: `${ROOTS.DASHBOARD}/memory/insights/users`,
      user: (id) => `${ROOTS.DASHBOARD}/memory/insights/users/${encodeURIComponent(id)}`,
    },

  },
};
